import React, { useEffect } from 'react';
import Media from 'react-media';
import queryString from 'query-string';
import Cookie from 'js-cookie';
import styled from 'styled-components/macro';
import DesktopLanding from './DesktopLanding';
import MobileLanding from './MobileLanding';
import AuthStore from 'Store/AuthStore';
import { Spinner, theme } from 'Ui';
import LandingStore from './LandingStore';
import { setCookie } from 'Utils/cookie';
import Cookies from 'js-cookie';

const Loading = styled.div`
  display: flex;
  height: 80vh;
  align-items: center;
  justify-content: center;
`;

const paramsUrls = queryString.parse(window.location.search);

const { site, gclid } = paramsUrls;

if (site) {
  const configCookie = { domain: '.bazarchic.com', expires: 30, secure: true };
  Cookie.set('site', site, configCookie);
  const objectCookie = {
    path: '/',
    expires: 30,
    secure: true,
    name: 'site',
    value: site,
  };
  setCookie(objectCookie);
}

if (gclid) {
  const objectCookieRedirectUrl = {
    path: '/',
    expires: 1,
    secure: true,
    name: 'redirection_url',
    value: `/accueil/index/${window.location.search}`,
  };
  setCookie(objectCookieRedirectUrl);
}

export default () => {
  const isLoggedIn = AuthStore.useStoreState((state) => state.isLoggedIn);
  if (isLoggedIn) {
    window.location.href = '/';
  }
  return (
    <>
      {isLoggedIn ? (
        <Loading>
          <Spinner size={50} color={theme.light.colors.purple} />
        </Loading>
      ) : (
        <LandingStore.Provider>
          <Media query={{ minWidth: 768 }} render={() => <DesktopLanding />} />
          <Media query={{ maxWidth: 767 }} render={() => <MobileLanding />} />
        </LandingStore.Provider>
      )}
    </>
  );
};
